import { useIntl } from "react-intl";
import { useCallback } from "react";
import type { Language } from "src/shared/objects/Language";

export const useGetLanguageName = () => {
  const intl = useIntl();
  return useCallback(
    (language: Language) => {
      return language.languageName[intl.locale];
    },
    [intl.locale],
  );
};
